<template>
  <div>
    <iframe
      src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fwvw.manan.mn%2F&tabs=timeline&width=360&height=400&small_header=true&adapt_container_width=false&hide_cover=false&show_facepile=true&appId=924879107670926"
      width="100%"
      height="400"
      style="border:none;overflow:hidden"
      scrolling="no"
      frameborder="0"
      allowTransparency="true"
      allow="encrypted-media"
    ></iframe>
    <Timeline
      :id="twitterId"
      class="mt-3"
      :sourceType="'likes'"
      :options="{ height: twitterHeight, linkColor: twitterColor }"
    />
  </div>
</template>

<script>
import { Timeline } from "vue-tweet-embed";

export default {
  components: {
    Timeline
  },
  data() {
    return {
      twitterId: "MANANmn2",
      twitterHeight: "400",
      twitterColor: "#830044"
    };
  }
};
</script>

<style scoped></style>
